import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { HEADER_DATA_SOURCE } from '../../../externals';
import { useQuery } from '@apollo/client';
import { GET_ONBOARDING_DATA } from './onboardingOperations';
import { logGQLErrors } from '../../../shared/logGQLErrors';
export var useOnboardingData = function useOnboardingData(_ref) {
  var skip = _ref.skip;
  return useQuery(GET_ONBOARDING_DATA, {
    context: _defineProperty({}, HEADER_DATA_SOURCE, true),
    skip: skip,
    ssr: false,
    onError: function onError(error) {
      return logGQLErrors('Header - User onboarding data fetching failed', error);
    }
  });
};